<template>
  <!-- 応募 -->
  <div :class="{'my-box': speaker==='my', 'other-box': speaker==='other'}">
    <div :class="{'my-chlid': speaker==='my', 'other-chlid': speaker==='other'}" v-if="checkUploadType()">
      <b-upload v-model="file" drag-drop v-bind="sended">
        <section class="upload-section">
          <div class="content has-text-centered">
            <p>
              <b-icon icon="upload" size="is-large"></b-icon>
            </p>
            <p>ファイルをアップロードしてください</p>
          </div>
        </section>
      </b-upload>
    </div>
    <div :class="{'my-chlid': speaker==='my', 'other-chlid': speaker==='other'}" v-if="checkUploadType()">
      <div class="btn-box">
        <span class="tag is-primary" style="margin-bottom: 8px;" v-if="file&&!isNowButton()">
          {{file.name}}
          <button class="delete is-small"
            type="button"
            @click="deleteFile()">
          </button>
        </span>
        <button class="button is-primary is-fullwidth" @click.once="sendfile()" v-if="file && !sendedFlg && !isNowButton()">送信</button>
        <button class="button is-primary is-fullwidth" disabled v-else>送信</button>
      </div>
    </div>
    <div :class="{'my-chlid': speaker==='my', 'other-chlid': speaker==='other'}" v-if="!checkUploadType()">
      <!-- アップロード -->
      <div class="resume-upload-box" v-if="imageUploadStepNew===0">
        <p class="message"
          :style="{
            'background': speaker==='my' ? color.balloonMy : color.balloonOtr + '!important', 
            'color': autoColor(speaker==='my' ? color.balloonMy : color.balloonOtr),
            'filter': shadowStyle(color.shadowType)}">カメラなどで左半分・右半分とお取りいただき、画像をアップロードしてください。写真に影が写らないようにし、全体の文字が見える形でアップロードお願いいたします。</p>
        <div class="step-bar" :style="getStepFix(speaker)">
          <div class="bar">
            <p   class="step" :style="getColorStyleStep(0)">Step 1</p>
            <div class="step-message" :style="getBgColorStyleStep(0)"></div>
          </div>
          <div class="bar">
            <p   class="step" :style="getColorStyleStep(1)">Step 2</p>
            <div class="step-message" :style="getBgColorStyleStep(1)"></div>
          </div>
          <div class="bar">
            <p   class="step" :style="getColorStyleStep(2)">Step 3</p>
            <div class="step-message" :style="getBgColorStyleStep(2)"></div>
          </div>
        </div>
        <div class="img-upload-box" :style="getFix(speaker)">
          <div style="width: 49%; height: auto;">
            <div class="wrapper-cover-img">
              <div style="position: absolute; display: flex; justify-content: center; align-items: center; z-index: 1; width: 100%; height: 100%; color: white; font-size: 120px; background: rgba(0, 0, 0, 0.5);">
                A
              </div>
              <img src="@/assets/template/resume_A.jpeg" style="width: 70%; height: auto;"/>
            </div>
            <b-upload style="margin-top: 16px;" v-model="fileLeft">
              <a class="button is-primary is-small">左半分をｱｯﾌﾟﾛｰﾄﾞ</a>
            </b-upload>
            <p style="font-size: smaller;" v-if="fileLeft != null"><span class="mdi mdi-check-outline" style="margin-right: 8px;"></span>アップロード完了</p>
          </div>
          <div style="width: 49%; height: auto;">
            <div class="wrapper-cover-img">
              <div style="position: absolute; display: flex; justify-content: center; align-items: center; z-index: 1; width: 100%; height: 100%; color: white; font-size: 120px; background: rgba(0, 0, 0, 0.5);">
                B
              </div>
              <img src="@/assets/template/resume_B.jpeg" style="width: 70%; height: auto;"/>
            </div>
            <b-upload style="margin-top: 16px;" v-model="fileRight">
              <a class="button is-primary is-small">右半分をｱｯﾌﾟﾛｰﾄﾞ</a>
            </b-upload>
            <p style="font-size: smaller;" v-if="fileRight != null"><span class="mdi mdi-check-outline" style="margin-right: 8px;"></span>アップロード完了</p>
          </div>
          <button class="button is-primary is-small is-fullwidth" style="margin-top: 16px;" @click="registerOCRNew()" :disabled="ocrResumeRows.length<2">読み込む</button>
        </div>
      </div>
      <!-- ローディング -->
      <div class="resume-upload-box" v-if="imageUploadStepNew===1">
        <p class="message"
          :style="{
            'background': speaker==='my' ? color.balloonMy : color.balloonOtr + '!important', 
            'color': autoColor(speaker==='my' ? color.balloonMy : color.balloonOtr),
            'filter': shadowStyle(color.shadowType)}" v-if="isOCRReading">現在履歴書を読み込んでおります。今しばらくお待ちください。</p>
        <p class="message"
          :style="{
            'background': speaker==='my' ? color.balloonMy : color.balloonOtr + '!important', 
            'color': autoColor(speaker==='my' ? color.balloonMy : color.balloonOtr),
            'filter': shadowStyle(color.shadowType)}" v-else>読み込みが完了しました。履歴書に修正箇所がございましたら、修正をお願い致します。</p>
        <div class="step-bar">
          <div class="bar">
            <p   class="step" :style="getColorStyleStep(0)">Step 1</p>
            <div class="step-message" :style="getBgColorStyleStep(0)"></div>
          </div>
          <div class="bar">
            <p   class="step" :style="getColorStyleStep(1)">Step 2</p>
            <div class="step-message" :style="getBgColorStyleStep(1)"></div>
          </div>
          <div class="bar">
            <p   class="step" :style="getColorStyleStep(2)">Step 3</p>
            <div class="step-message" :style="getBgColorStyleStep(2)"></div>
          </div>
        </div>
        <div style="color: #222;" v-if="isOCRReading">
          <span class="mdi mdi-loading mdi-spin mdi-48px"></span>
        </div>
        <div v-if="!isOCRReading">
          <!-- step 1 基本情報 -->
          <div style="padding: 16px;" v-if="rirekisyoStepNew===0">
            <h2 style="padding: 8px; font-size: larger;"><b>基本情報</b></h2>
            <p class="input-box" style="border-top: solid thin #ccc;">
              <span class="input-label">名前（ふりがな）</span>
              <input class="input input-modal" v-model="ocrInputDataLeft.name_furigana" /></p>
            <p class="input-box">
              <span class="input-label">名前</span>
                <input class="input input-modal" v-model="ocrInputDataLeft.name"/></p>
            <p class="input-box">
              <span class="input-label">性別</span>
                <input class="input input-modal" v-model="ocrInputDataLeft.sex"/></p>
            <p class="input-box">
              <span class="input-label">誕生日</span>
              <input class="input input-modal" v-model="ocrInputDataLeft.birthday"/></p>
            <p class="input-box">
              <span class="input-label">住所（ふりがな）</span>
              <input class="input input-modal" v-model="ocrInputDataLeft.addr_furigana"/>
            </p>
            <p class="input-box">
              <span class="input-label">住所</span>
              <input class="input input-modal" v-model="ocrInputDataLeft.addr"/>
            </p>
            <p class="input-box">
              <span class="input-label">TEL</span>
              <input class="input input-modal" v-model="ocrInputDataLeft.tel"/>
            </p>
            <p class="input-box">
              <span class="input-label">Email</span>
              <input class="input input-modal" v-model="ocrInputDataLeft.email"/>
            </p>
          </div>
          <!-- step 2 経歴1 -->
          <div style="padding: 16px;" v-if="rirekisyoStepNew===1">
            <h2 style="padding: 8px; font-size: larger;"><b>経歴</b></h2>
            <table class="table-box">
              <tr>
                <th class="table-box-header" style="width: 120px;">年</th>
                <th class="table-box-header" style="width: 50px;">月</th>
                <th class="table-box-header">学歴・職歴</th>
              </tr>
              <tr v-for="(r, idx) in ocrInputDataLeft.reki_nen" :key="idx">
                <td>
                  <input class="input input-table" style="width: 120px;" v-model="ocrInputDataLeft.reki_nen[idx]"/>
                </td>
                <td>
                  <input class="input input-table" style="width: 50px;" v-model="ocrInputDataLeft.reki_tsuki[idx]"/>
                </td>
                <td>
                  <input class="input input-table" v-model="ocrInputDataLeft.reki[idx]"/>
                </td>
              </tr>
              <tr v-for="(r, idx2) in keirekiTable" :key="idx2" v-if="keirekiTable.length > 0">
                <td>
                  <input placeholder="2019" class="input input-table" style="width: 120px;" v-model="keirekiTable[idx2].keireki_nen"/>
                </td>
                <td>
                  <input placeholder="3" class="input input-table" style="width: 50px;" v-model="keirekiTable[idx2].keireki_tsuki"/>
                </td>
                <td>
                  <input placeholder="○○株式会社 入社" class="input input-table" v-model="keirekiTable[idx2].keireki"/>
                </td>
              </tr>
            </table>
            <button @click="keirekiTable.push(JSON.parse(JSON.stringify(keirekiData)))" class="button is-primary is-fullwidth" style="border-radius: 0; font-size: smaller;" v-if="keirekiTable.length<9">＋ 追加する</button>
          </div>
          <!-- step 3 経歴2 -->
          <div v-if="rirekisyoStepNew===2">
            <h2 style="padding: 8px; font-size: larger;"><b>経歴 ②</b></h2>
            <table class="table-box">
              <tr>
                <th class="table-box-header" style="width: 120px;">年</th>
                <th class="table-box-header" style="width: 50px;">月</th>
                <th class="table-box-header">学歴・職歴</th>
              </tr>
              <tr v-for="(r, idx) in ocrInputDataRight.reki_nen" :key="idx" v-if="ocrInputDataRight.reki_nen">
                <td>
                  <input class="input input-table" style="width: 120px;" v-model="ocrInputDataRight.reki_nen[idx]"/>
                </td>
                <td>
                  <input class="input input-table" style="width: 50px;" v-model="ocrInputDataRight.reki_tsuki[idx]"/>
                </td>
                <td>
                  <input class="input input-table" v-model="ocrInputDataRight.reki[idx]"/>
                </td>
              </tr>
              <tr v-for="(r, idx2) in keirekiTable2" :key="idx2" v-if="keirekiTable2.length > 0">
                <td>
                  <input placeholder="2019" class="input input-table" style="width: 120px;" v-model="keirekiTable2[idx2].keireki_nen"/>
                </td>
                <td>
                  <input placeholder="3" class="input input-table" style="width: 50px;" v-model="keirekiTable2[idx2].keireki_tsuki"/>
                </td>
                <td>
                  <input placeholder="○○株式会社 入社" class="input input-table" v-model="keirekiTable2[idx2].keireki"/>
                </td>
              </tr>
            </table>
            <button @click="keirekiTable2.push(JSON.parse(JSON.stringify(keirekiData)))" class="button is-primary is-fullwidth" style="border-radius: 0; font-size: smaller;" v-if="keirekiTable2.length<9">＋ 追加する</button>
          </div>
          <!-- step 3 資格1 -->
          <div style="padding: 16px;" v-if="rirekisyoStepNew===3">
            <h2 style="padding: 8px; font-size: larger;"><b>資格</b></h2>
            <table class="table-box">
              <tr>
                <th class="table-box-header" style="width: 120px;">年</th>
                <th class="table-box-header" style="width: 50px;">月</th>
                <th class="table-box-header">免許・資格</th>
              </tr>
              <tr v-for="(r, idx) in ocrInputDataRight.shikaku_nen" :key="idx" v-if="ocrInputDataRight.shikaku_nen">
                <td>
                  <input class="input input-table" style="width: 120px;" v-model="ocrInputDataRight.shikaku_nen[idx]"/>
                </td>
                <td>
                  <input class="input input-table" style="width: 50px;" v-model="ocrInputDataRight.shikaku_tsuki[idx]"/>
                </td>
                <td>
                  <input class="input input-table" v-model="ocrInputDataRight.shikaku[idx]">
                </td>
              </tr>
              <tr v-for="(r, idx2) in shikakuTable" :key="idx2" v-if="shikakuTable.length > 0">
                <td>
                  <input placeholder="2019" class="input input-table" style="width: 120px;" v-model="shikakuTable[idx2].shikaku_nen"/>
                </td>
                <td>
                  <input placeholder="3" class="input input-table" style="width: 50px;" v-model="shikakuTable[idx2].shikaku_tsuki"/>
                </td>
                <td>
                  <input placeholder="普通自動車免許 取得" class="input input-table" v-model="shikakuTable[idx2].shikaku"/>
                </td>
              </tr>
            </table>
            <button @click="shikakuTable.push(JSON.parse(JSON.stringify(shikakuData)))" class="button is-primary is-fullwidth" style="border-radius: 0; font-size: smaller;" v-if="shikakuTable.length<8">＋ 追加する</button>
          </div>
          <!-- step 4 詳細情報 -->
          <div style="padding: 16px;" v-if="rirekisyoStepNew===4">
            <h2 style="padding: 8px; font-size: larger;"><b>詳細情報</b></h2>
            <p class="input-box" style="border-top: solid thin #ccc;" v-if="existItem(ocrInputDataRight.shibo_doki)">
              <span class="input-label">志望動機 / 自己PR / 趣味特技など</span>
              <textarea class="textarea input-modal" placeholder="志望動機 / 自己PR / 趣味特技" v-model="ocrInputDataRight.shibo_doki"/>
            </p>
            <p class="input-box" v-if="existItem(ocrInputDataRight.tsukin_jikan)">
              <span class="input-label">通勤時間</span>
              <input class="input input-modal" v-model="ocrInputDataRight.tsukin_jikan"/>
            </p>
            <p class="input-box" v-if="existItem(ocrInputDataRight.fuyo_kazoku)">
              <span class="input-label">扶養家族</span>
              <input class="input input-modal" v-model="ocrInputDataRight.fuyo_kazoku"/>
            </p>
            <p class="input-box" v-if="existItem(ocrInputDataRight.haigusha_umu)">
              <span class="input-label">配偶者有無</span>
              <input class="input input-modal" v-model="ocrInputDataRight.haigusha_umu"/>
            </p>
            <p class="input-box" v-if="existItem(ocrInputDataRight.haigusha_fuyo_gimu)">
              <span class="input-label">配偶者扶養義務</span>
              <input class="input input-modal" v-model="ocrInputDataRight.haigusha_fuyo_gimu"/>
            </p>
            <p class="input-box" v-if="existItem(ocrInputDataRight.kibo)">
              <span class="input-label">希望</span>
              <input class="input input-modal" v-model="ocrInputDataRight.kibo"/>
            </p>
          </div>
          <div style="padding: 16px;" v-if="!isOCRReading">
            <button class="button is-small" style="margin-right: 8px;" @click="rirekisyoStepNew > 0 ? rirekisyoStepNew-- : rirekisyoStepNew=0; rirekisyoStepNew==2&&ocrInputDataRight.reki_nen[0]==''&&ocrInputDataRight.reki_nen[1]==''&&ocrInputDataRight.reki_nen[2]==''&&ocrInputDataRight.reki_nen[3]==''? rirekisyoStepNew-- : rirekisyoStepNew=rirekisyoStepNew" :disabled="rirekisyoStepNew == 0 || isLoadingResume">＜ 前へ戻る</button>
            <button class="button is-small" style="margin-left: 8px;"  @click="rirekisyoStepNew < 4 ? rirekisyoStepNew++ : rirekisyoStepNew=4; rirekisyoStepNew==2&&ocrInputDataRight.reki_nen[0]==''&&ocrInputDataRight.reki_nen[1]==''&&ocrInputDataRight.reki_nen[2]==''&&ocrInputDataRight.reki_nen[3]==''? rirekisyoStepNew++ : rirekisyoStepNew=rirekisyoStepNew" :disabled="rirekisyoStepNew == 4 || isLoadingResume">＞ 次へ進む</button>
            <button class="button is-small is-primary" style="margin-left: 8px;" @click.once="makeResume()" v-if="rirekisyoStepNew == 4 && !isNowButton() && !isLoadingResume">登録する</button>
            <button class="button is-primary" style="margin-left: 8px;" v-if="rirekisyoStepNew == 4 && !isNowButton() && isLoadingResume"><span class="mdi mdi-loading mdi-spin"></span>しばらくお待ちください</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import hex2rgb from "@/functions/hex2rgb"
import createUUID from '@/functions/createUUID'
// 外部関数
import {
  autoColor,
  shadowStyle,
  isNowButton
} from "@/functions/balloonFunc"

export default {
  name: "UploadParts",
  props: ['speaker', 'color', 'parameter', 'lastIndex', 'logIndex', 'isDemo', 'sendedFlg'],
  watch: {
    fileLeft () {
      let reader = new FileReader()
      console.log(this.fileLeft)
      reader.onload = (e) => {
        console.log(e)
        this.ocrResumeRows.push({
          filename: this.fileLeft.name,
          data: e.target.result.replace(/^.*,/, '')
        })
      }
      reader.readAsDataURL(this.fileLeft)
    },
    fileRight () {
      let reader = new FileReader()
      reader.onload = (e) => {
        console.log(e)
        this.ocrResumeRows.push({
          filename: this.fileRight.name,
          data: e.target.result.replace(/^.*,/, '')
        })
      }
      reader.readAsDataURL(this.fileRight)
    },
    ocrData () {
      this.ocrInputDataLeft  = {
        name_furigana : this.ocrData.data[0].name_furigana ? this.ocrData.data[0].name_furigana[0] : null,
        name          : this.ocrData.data[0].name ? this.ocrData.data[0].name[0] : null,
        sex           : this.ocrData.data[0].sex ? this.ocrData.data[0].sex[0] : null,
        birthday      : this.ocrData.data[0].birthday ? this.ocrData.data[0].birthday[0] : null,
        addr_furigana : this.ocrData.data[0].addr_furigana ? this.ocrData.data[0].addr_furigana[0] : null,
        addr          : this.ocrData.data[0].addr ? this.ocrData.data[0].addr[0] : null,
        tel           : this.ocrData.data[0].tel ? this.ocrData.data[0].tel[0] : null,
        email         : this.ocrData.data[0].email ? this.ocrData.data[0].email[0] : null,
        reki_nen      : this.ocrData.data[0].reki_nen ? this.ocrData.data[0].reki_nen : [],
        reki_tsuki    : this.ocrData.data[0].reki_tsuki ? this.ocrData.data[0].reki_tsuki : [],
        reki          : this.ocrData.data[0].reki ? this.ocrData.data[0].reki : [],
      }
      this.ocrInputDataRight = {
        reki_nen           : this.ocrData.data[1].reki_nen ? this.ocrData.data[1].reki_nen : null,
        reki_tsuki         : this.ocrData.data[1].reki_tsuki ? this.ocrData.data[1].reki_tsuki : null,
        reki               : this.ocrData.data[1].reki ? this.ocrData.data[1].reki : null,
        shikaku_nen        : this.ocrData.data[1].shikaku_nen ? this.ocrData.data[1].shikaku_nen : null,
        shikaku_tsuki      : this.ocrData.data[1].shikaku_tsuki ? this.ocrData.data[1].shikaku_tsuki : null,
        shikaku            : this.ocrData.data[1].shikaku ? this.ocrData.data[1].shikaku : null,
        tsukin_jikan       : this.ocrData.data[1].tsukin_jikan ? this.ocrData.data[1].tsukin_jikan[0] : null,
        moyori_eki         : this.ocrData.data[1].moyori_eki ? this.ocrData.data[1].moyori_eki[0] : null,
        fuyo_kazoku        : this.ocrData.data[1].fuyo_kazoku ? this.ocrData.data[1].fuyo_kazoku[0] : null,
        haigusha_umu       : this.ocrData.data[1].haigusha_umu ? this.ocrData.data[1].haigusha_umu[0] : null,
        haigusha_fuyo_gimu : this.ocrData.data[1].haigusha_fuyo_gimu ? this.ocrData.data[1].haigusha_fuyo_gimu[0] : null,
        shibo_doki         : this.ocrData.data[1].shibo_doki ? this.ocrData.data[1].shibo_doki[0] : null,
        kibo               : this.ocrData.data[1].kibo ? this.ocrData.data[1].kibo[0] : null,
      }
    }
  },
  methods: {
    getStepFix (s) {
      if (s === 'my') return {'margin-left': '0'}
      else return {'margin-left': '0px'}
    },
    getFix (s) {
      if (s === 'my') return {'margin-left': '0', 'width': 'calc(100% + 80px)'}
      else return {'margin-left': '0px'}
    },
    isNowButton () {
      return isNowButton(this.logIndex, this.lastIndex, this.speaker)
    },
    autoColor (c) {
      let color = hex2rgb(c)
      return autoColor(color)
    },
    shadowStyle (t) {
      return shadowStyle(t)
    },
    deleteFile () {
      this.file = null
    },
    sendfile () {
      this.$emit('sendfile', this.file, 1)
    },
    checkUploadType () {
      try {
        return !this.parameter.is_resume
      } catch (e) {
        return true
      }
    },
    registerOCRNew () {
      if (this.parameter.to_google_drive) {
        this.$emit('sendfile', this.fileLeft, 1)
        this.$emit('sendfile', this.fileRight, 2)
      } else {
        this.$store.dispatch('directtalk/uploadOCR',this.ocrResumeRows)
        this.imageUploadStepNew++
      }
    },
    existItem (item) {
      return item !== null && item !== undefined
    },
    makeResume () {
      //バリデーション
      if (!(this.ocrInputDataLeft.name && this.ocrInputDataLeft.name.trim())) {
        alert('名前は必須項目です。')
        return
      }
      if (this.ocrInputDataLeft.tel) {
        if (this.ocrInputDataLeft.tel.length > 20) {
          alert('電話番号は20文字以下でお願いいたします。')
          return
        }
      }
      //整形
      var keireki = []
      var shikaku = []
      for (let i in this.ocrInputDataLeft.reki_nen) {
        let pushData = {}
        if (this.ocrInputDataLeft.reki_nen[i] && this.ocrInputDataLeft.reki_tsuki[i] && this.ocrInputDataLeft.reki[i]) {
          pushData['reki_nen']   = this.ocrInputDataLeft.reki_nen[i]
          pushData['reki_tsuki'] = this.ocrInputDataLeft.reki_tsuki[i]
          pushData['reki']       = this.ocrInputDataLeft.reki[i]
          keireki.push(pushData)
        }
      }
      for (let i in this.ocrInputDataRight.reki_nen) {
        let pushData = {}
        if (this.ocrInputDataRight.reki_nen[i] && this.ocrInputDataRight.reki_tsuki[i] && this.ocrInputDataRight.reki[i]) {
          pushData['reki_nen']   = this.ocrInputDataRight.reki_nen[i]
          pushData['reki_tsuki'] = this.ocrInputDataRight.reki_tsuki[i]
          pushData['reki']       = this.ocrInputDataRight.reki[i]
          keireki.push(pushData)
        }
      }
      for (let i in this.keirekiTable) {
        let pushData = {}
        if (this.keirekiTable[i].reki_nen && this.keirekiTable[i].reki_tsuki && this.keirekiTable[i].reki) {
          pushData['reki_nen']   = this.keirekiTable[i].reki_nen
          pushData['reki_tsuki'] = this.keirekiTable[i].reki_tsuki
          pushData['reki']       = this.keirekiTable[i].reki
          keireki.push(pushData)
        }
      }
      for (let i in this.keirekiTable2) {
        let pushData = {}
        if (this.keirekiTable2[i].reki_nen && this.keirekiTable2[i].reki_tsuki && this.keirekiTable2[i].reki) {
          pushData['reki_nen']   = this.keirekiTable2[i].reki_nen
          pushData['reki_tsuki'] = this.keirekiTable2[i].reki_tsuki
          pushData['reki']       = this.keirekiTable2[i].reki
          keireki.push(pushData)
        }
      }
      for (let i in this.ocrInputDataRight.shikaku_nen) {
        let pushData = {}
        if (this.ocrInputDataRight.shikaku_nen[i] && this.ocrInputDataRight.shikaku_tsuki[i] && this.ocrInputDataRight.shikaku[i]) {
          pushData['shikaku_nen']   = this.ocrInputDataRight.shikaku_nen[i]
          pushData['shikaku_tsuki'] = this.ocrInputDataRight.shikaku_tsuki[i]
          pushData['shikaku']       = this.ocrInputDataRight.shikaku[i]
          shikaku.push(pushData)
        }
      }
      for (let i in this.shikakuTable) {
        let pushData = {}
        if (this.shikakuTable[i].shikaku_nen && this.shikakuTable[i].shikaku_tsuki && this.shikakuTable[i].shikaku) {
          pushData['shikaku_nen']   = this.shikakuTable[i].shikaku_nen
          pushData['shikaku_tsuki'] = this.shikakuTable[i].shikaku_tsuki
          pushData['shikaku']       = this.shikakuTable[i].shikaku
          shikaku.push(pushData)
        }
      }
      // ここから反映作業
      for (let k of keireki) {
        let createCareer = {
          career_year:  k.reki_nen,
          career_month: k.reki_tsuki,
          career_body:  k.reki,
          seeker:       this.seeker.pk,
        }
        if (!this.isDemo) {
          this.$store.dispatch('directtalk/createCareerAny', createCareer)
        }
      }
      for (let s of shikaku) {
        let createQualification = {
          qualification_year:  s.shikaku_nen,
          qualification_month: s.shikaku_tsuki,
          qualification_body:  s.shikaku,
          seeker: this.seeker.pk,
        }
        if (!this.isDemo) {
          this.$store.dispatch('directtalk/createQualificationAny', createQualification)
        }
      }
      let sexTemp = null
      if (this.ocrInputDataLeft.sex) {
        sexTemp = this.ocrInputDataLeft.sex.indexOf("男") >= 0 ? '1' : this.ocrInputDataLeft.sex.indexOf("女") >= 0 ? '2' : '0'
      }
      let updateSeeker = {
        id: this.seeker.pk,
        name: this.ocrInputDataLeft.name ? this.ocrInputDataLeft.name : this.seeker.name,
        name_phonetic: this.ocrInputDataLeft.name_furigana,
        sex: sexTemp,
        address: this.ocrInputDataLeft.addr,
        tel: this.ocrInputDataLeft.tel,
        email: this.ocrInputDataLeft.email,
        requirement: this.ocrInputDataRight.kibo ? this.ocrInputDataRight.kibo : '',
      }
      if (!this.isDemo) {
        this.$store.dispatch('directtalk/updateSeekerAny', updateSeeker)
      }

      this.isLoadingResume = true
      setTimeout(() => {
        this.isLoadingResume = false
        this.$emit('sendfile', this.fileLeft, 0)
        this.$emit('sendfile', this.fileRight, 1)
      }, 5000)
      
    },
    getBgColorStyleStep (num) {
      if (this.imageUploadStepNew != num && this.imageUploadStepNew > num) {
        return {
          background: '#ee93d0 !important'
        }
      } else if (this.imageUploadStepNew != num && this.imageUploadStepNew < num) {
        return {
          background: 'grey !important'
        }
      } else if (this.imageUploadStepNew == num) {
        return {
          background: '#dd43d0 !important'
        }
      }
    },
    getColorStyleStep (num) {
      if (this.imageUploadStepNew != num && this.imageUploadStepNew > num) {
        return {
          color: '#ee93d0 !important'
        }
      } else if (this.imageUploadStepNew != num && this.imageUploadStepNew < num) {
        return {
          color: 'grey !important'
        }
      } else if (this.imageUploadStepNew == num) {
        return {
          color: '#dd43d0 !important'
        }
      }
    }
  },
  computed: {
    ...mapState('directtalk', ['data', 'seeker', 'applylist', 'isApplyListLoading', 'isApplyListNone', 'downloadCSV', 'isMakingCSV', 'resumeLoading', 'pdfFile', 'isOCRReading', 'ocrData']),
    sended () {
      return this.sendedFlg ? { disabled: true } : { disabled: false }
    }
  },
  data () {
    return {
      file: null,
      fileLeft: null,
      fileRight: null,
      ocrResumeRows: [],
      imageUploadStepNew: 0,
      shikakuData: {
        'shikaku_nen': null,
        'shikaku_tsuki': null,
        'shikaku': null
      },
      keirekiData: {
        'reki_nen': null,
        'reki_tsuki': null,
        'reki': null
      },
      shikakuTable: [],
      keirekiTable: [],
      keirekiTable2: [],
      rirekisyoStepNew: 0,
      isLoadingResume: false,
      ocrInputDataLeft: null,
      ocrInputDataRight: null,
    }
  }
};
</script>
​
<style lang="scss" scoped>
.message {
  text-align: left;
  padding: 16px;
  width: auto;
  max-width: -webkit-fill-available;
  word-wrap: break-word;
  border-radius: 8px;
  font-size: smaller;
  white-space: pre-line;
  transition: 0.7s;
}
.message-title {
  filter: none; font-size: 14px; margin-bottom: 5px; margin-top: 5px; white-space: pre-wrap; text-align: left;
}
.my-box {
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  margin-right: 10px;
}
.other-box {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-left: 10px;
}
.my-chlid {
  display: flex;
  justify-content: flex-end;
}
.other-chlid {
  display: flex;
  justify-content: flex-start;
}
.upload-section {
  padding: 20px; color: black; background: #f2f2f2;
}
.btn-box {
  text-align: center; margin-top: 16px; width: 100%; max-width: 318px;
}
.step-bar {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
}
.step-bar > .bar {
  width: 33%;
  height: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;
}
.bar > .step {
  width: calc(100% - 16px); text-align: center; text-align: center; font-size: smaller;
}
.bar > .step-message {
  width: calc(100% - 16px); text-align: center; height: 8px; background: grey;
}
.resume-upload-box {
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  position: relative;
}
.upload-title {
  width: 100%; padding-left: 16px; padding-top: 16px;
}
.wrapper-cover-img {
  position: relative;
}
.img-upload-box {
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  flex-wrap: wrap;
}
.input-modal {
  border-radius: 0;
  font-size: smaller;
}
.input-table {
  border-radius: 0;
  font-size: small;
}
.table-box {
  font-size: smaller;
  width: -webkit-fill-available;
}
.input-label {
  font-size: smaller;
  padding: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/BalloonParts/UploadParts.vue